import { render } from "./confirm-modal.vue?vue&type=template&id=83744d48&scoped=true"
import script from "./confirm-modal.vue?vue&type=script&lang=js"
export * from "./confirm-modal.vue?vue&type=script&lang=js"

import "./confirm-modal.vue?vue&type=style&index=0&id=83744d48&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83744d48"]])

export default __exports__